import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { PageMode } from '@confluence/page-utils/entry-points/enums';

import stateResolverPreloadAnnotationsDataQuery, {
	type stateResolverPreloadAnnotationsDataQuery$data,
	type stateResolverPreloadAnnotationsDataQuery$variables,
} from './__generated__/stateResolverPreloadAnnotationsDataQuery.graphql';
import { buildPreloadAnnotationsDataQueryVariables } from './stateResolver';

/**
 * Standalone function to preload annotation state data
 * Should only be called in route preloaders. Elsewhere use getPreloadedAnnotationsData
 * @param contentId - The ID of the content to preload
 * @param isViewPage - If true, queries for CURRENT and ARCHIVED. If false, queries for CURRENT, ARCHIVED, and DRAFT.
 */
export const preloadAnnotationsData = async (contentId: string, isViewPage: boolean = false) => {
	if (!contentId) {
		return Promise.resolve({ data: null });
	}

	const pageMode = isViewPage ? PageMode.VIEW : PageMode.LIVE;

	// Use query from query-preloader-tools for route preloaders
	return query<
		stateResolverPreloadAnnotationsDataQuery$data,
		stateResolverPreloadAnnotationsDataQuery$variables
	>({
		query: stateResolverPreloadAnnotationsDataQuery,
		variables: buildPreloadAnnotationsDataQueryVariables(contentId, pageMode),
		fetchPolicy: 'cache-first',
	});
};
